import * as z from 'zod';

export const CreateUserZodSchema = z.object({
  directoryName: z.string(),
  email: z.string(),
  password: z
    .string()
    .min(8, {
      message: 'Hasło powinno zawierać co najmniej 8 znaków.',
    })
    .max(64, {
      message: 'Hasło powinno zawierać maksymalnie 64 znaki.',
    })
    .refine((value) => /[!@#$%^&*(),.?":{}|<>_\\/-]/.test(value), {
      message: 'Hasło powinno zawierać przynajmniej jeden znak specjalny.',
    })
    .refine((value) => /[A-Z]/.test(value), {
      message: 'Hasło powinno zawierać co najmniej jedną wielką literę.',
    }),
});
